import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-opacity duration-300" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-123">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col animate-in fade-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-124">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-100" data-id="element-125">
          <h2 id="modal-title" className="text-2xl font-bold text-slate-900 font-heading" data-id="element-126">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" aria-label="Cerrar modal" data-id="element-127">
            <X className="w-5 h-5" data-id="element-128" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto text-slate-600 space-y-4 leading-relaxed" data-id="element-129">
          {children}
        </div>

        {/* Footer (optional close button) */}
        <div className="p-4 border-t border-slate-100 flex justify-end" data-id="element-130">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors" data-id="element-131">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}